/**
* @name: government
* @author: weiyong
* @date: 2023-04-01 21:06
* @description：government
* @update: 2023-04-01 21:06
*/
<template>
  <div :class="prefixCls" class="scaLayout wrapper-horizontal">
    <left-layout-div/>
    <right-layout-div/>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "scaLayout",
});
</script>

<script lang="ts" setup>

import LeftLayoutDiv from "@/layouts/layoutFrame/scaLayout/components/left-layout-div.vue";
import RightLayoutDiv from "@/layouts/layoutFrame/scaLayout/components/right-layout-div.vue";
import {useDesign} from "@/hooks/web/useDesign";
import {ref} from "vue";

const {prefixCls} = useDesign('scaLayout');
const itemMenu = ref({});

onMounted(()=>{
  if(!(document.body.className.indexOf('scaLayout-body')>=0)){
    document.body.className=document.body.className+" scaLayout-body";
  }
})

</script>

<style type="text/css" lang="less">
@import './less/scalayout.less';
.scaLayout-body{
  .ant-menu-item.el-custom-sidebar-item .el-custom-sidebar-icon-container .open-item-label{
    padding-left: 10px;
  }

  // 菜单底为白时（theme=light）：强制菜单名称可见
  .side-menu.light {
    .open-item-label,
    .ant-menu-submenu-title,
    .el-custom-sidebar-item {
      color: #333 !important;
    }

    .ant-menu-item-selected .open-item-label,
    .ant-menu-item-selected .remix-icon,
    .ant-menu-submenu-selected > .ant-menu-submenu-title .open-item-label {
      color: var(--primary-color, #0a6cd5) !important;
    }
  }
}
.scaLayout{
  font-family: "Poppins", "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Helvetica, "Heiti SC";
}
.wrapper-horizontal {
  transition: all .3s;
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;

  .divider {
    margin-left: 0;
    margin-top: 6px;
    margin-bottom: 6px;
    height: 18px;
  }

  .el-divider--vertical {
    display: inline-block;
    width: 1px;
    height: 1em;
    margin: 0 8px;
    vertical-align: middle;
    position: relative;
    border-left: 1px var(--el-border-color) var(--el-border-style);
  }
}

.scaLayout.wrapper-horizontal {
  font-size: 18px;
}

.classicBlue.wrapper-horizontal,
.technology.wrapper-horizontal {
  font-size: var(--el-font-size-base, 14px);
  margin-bottom: 2px;
}
</style>
